import { useCartContext } from "@/src/context/CartContext";
import type { CartItem } from "@/src/types";

function LineItem({ item }: { item: CartItem }) {
    return (
        <div className="flex gap-4 items-center">
            <img
                src={item.image}
                alt={item.name}
                className="w-16 h-16 object-cover rounded-sm shrink-0"
                referrerPolicy="no-referrer"
            />
            <div className="flex-1 min-w-0">
                <p className="text-sm font-light truncate">{item.name}</p>
                <p className="text-xs text-stone-400 mt-0.5">Qty {item.quantity}</p>
            </div>
            <p className="text-sm font-light shrink-0">£{(item.price * item.quantity).toFixed(2)}</p>
        </div>
    );
}

export function OrderSummary() {
    const { cart, cartTotal } = useCartContext();
    const shipping = cartTotal >= 60 ? 0 : 4.5;
    const total = cartTotal + shipping;

    return (
        <div className="bg-stone-50 p-8 space-y-6 h-fit lg:sticky lg:top-32">
            <h2 className="font-serif text-xl italic">Order Summary</h2>

            <div className="space-y-4">
                {cart.map((item) => (
                    <LineItem key={item.id} item={item} />
                ))}
            </div>

            <div className="border-t border-stone-200 pt-6 space-y-3 text-sm font-light">
                <div className="flex justify-between">
                    <span className="text-stone-500">Subtotal</span>
                    <span>£{cartTotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-stone-500">Shipping</span>
                    <span>{shipping === 0 ? "Free" : `£${shipping.toFixed(2)}`}</span>
                </div>
                {shipping === 0 && (
                    <p className="text-xs text-stone-400 italic">Free shipping on orders over £60</p>
                )}
                <div className="flex justify-between font-medium text-base border-t border-stone-200 pt-4">
                    <span>Total</span>
                    <span>£{total.toFixed(2)}</span>
                </div>
            </div>
        </div>
    );
}
